// String → LucideIcon component map. Used by Kb*Page renderers to resolve
// icon names stored in the page_content jsonb back into the actual React
// component. Keep in sync with the icons that appear across content TSX
// files: search "from \"lucide-react\"" in src/pages/*/.

import {
  BookOpen,
  Brain,
  Clapperboard,
  ClipboardList,
  Eye,
  FileText,
  Hash,
  HeartHandshake,
  Instagram,
  LayoutTemplate,
  MessagesSquare,
  Microscope,
  NotebookPen,
  Shield,
  Sprout,
  Target,
  Video,
  type LucideIcon,
} from "lucide-react";

const ICONS: Record<string, LucideIcon> = {
  BookOpen,
  Brain,
  Clapperboard,
  ClipboardList,
  Eye,
  FileText,
  Hash,
  HeartHandshake,
  Instagram,
  LayoutTemplate,
  MessagesSquare,
  Microscope,
  NotebookPen,
  Shield,
  Sprout,
  Target,
  Video,
};

export function resolveIcon(name: string | undefined): LucideIcon | undefined {
  if (!name) return undefined;
  return ICONS[name];
}
